// 社員一覧画面
import React, { useState, useEffect, useCallback, useRef } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Button,
  Table,
  TableBody,
  TableCell,
  FormControl,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Snackbar,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogActions,
  DialogTitle,
  Tooltip
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import DeleteIcon from '@material-ui/icons/Delete';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  employeeMasterData,
  userRole,
  progressFlgState,
  userTenant
} from '../GlobalState';
import LoadingComponent from '../components/LoadingComponent';
import { Redirect, useHistory } from 'react-router-dom';
import {
  getEmployeeMasterList,
  deleteEmployeeMaster,
  getExportEmployeeItems,
  activateEmployeeById,
  getExportCustomEmployeeItems
} from '../apicalls/employeeMaster';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { CSVLink } from 'react-csv';
import PaginationComponent from '../components/PaginationComponent';
import { NotFoundPage } from './NotFoundPage';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { EMPLOYEE_TYPE, EMPLOYEE_ADD_INFO_TENANT_IDS } from '../const/Const';
import { TTenant } from '../types/common';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

interface State {
  arr: any;
}

interface CheckedState {
  check: any;
}

export const EmployeeMasterList: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission] = useRecoilState(userRole);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  //エクスポートの処理を分ける企業の判別
  const userTenantData = useRecoilValue<TTenant | undefined>(userTenant);
  const mode = (process.env.REACT_APP_MODE ||
    'dev') as keyof typeof EMPLOYEE_ADD_INFO_TENANT_IDS;
  const customerSpecificTenantIds = EMPLOYEE_ADD_INFO_TENANT_IDS[mode] || [];
  const isEmployeeAddInfo = userTenantData
    ? customerSpecificTenantIds.includes(userTenantData.id)
    : false;

  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        padding: 8,
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      table1: {
        padding: 8
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      topContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'space-between'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      },
      searchInput: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        margin: '24px 24px'
      },
      buttonArea: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        margin: '24px 6px'
      }
    })
  );

  const [employeeMasterIds, setEmployeeMasterIds] = useState<State>({
    arr: []
  });
  const [checked, setChecked] = useState<CheckedState>({ check: [] });
  const [pressed, setPressed] = useState([]);
  const [isSelected, setSelection] = useState(false);
  const [idToActivate, setIdToActivate] = useState<number>(0);
  const [openActivate, setOpenActivate] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [openSuccess, setOpenSuccess] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [displayLimit, setDisplayLimit] = useState<number>(10);
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const [employeeMasterApiData, setEmployeeMasterApiData] =
    useRecoilState(employeeMasterData);
  const changeEmployeeMasterApiData = useCallback(
    (newData: any) => setEmployeeMasterApiData(newData),
    [setEmployeeMasterApiData]
  );
  const [apiData, setApiData] = useState<any>(
    employeeMasterApiData !== null ? employeeMasterApiData : []
  );
  const [loading, setLoading] = useState(
    employeeMasterApiData !== null ? false : true
  );
  const [furigana, setFurigana] = useState('');
  const [count, setCount] = useState(0);

  const [checkBoxSelected, setCheckBoxSelected] = useState(false);
  const [myCheckExport, setMyCheckExport] = useState<any>([]);
  const [transactionData, setTransactionData] = useState<any>([]);
  const csvLink: any = useRef();
  const history: any = useHistory();

  // 社外パートナー画面から戻った場合は、社外パートナーをタブ表示する
  const defaultEmployeeType: number = history.location.state?.employeeType
    ? history.location.state.employeeType
    : EMPLOYEE_TYPE['INSIDE_EMPLOYEE'];

  // 社員タイプ(1:社員一覧、2:社外パートナー)
  const [employeeType, setEmployeeType] = useState<number>(defaultEmployeeType);

  const checkListOptions = [
    { name: '名前' },
    { furigana: 'ふりがな' },
    { email: 'メールアドレス' },
    { tel: '電話番号' },
    { privilage: '権限' },
    { group_names: '社員グループ名' },
    { partner_name: '業者名' },
    { enrollment_status: 'ステータス' },
    { department: '部署' },
    { occupation: '職種' },
    { position: '役職' },
    { remarks: '備考' }
  ];

  // 自社社員のCSVエクスポートでは業者名を選択できないようにする
  const filteredCheckListOptions =
    employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
      ? checkListOptions.filter(option => !('partner_name' in option))
      : checkListOptions;

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const getListOfEmployeeMasters = useCallback(() => {
    setProgressFlg(true);
    getEmployeeMasterList(
      furigana.trim(),
      currentPage,
      displayLimit,
      employeeType
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setProgressFlg(false);
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setProgressFlg(false);
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeEmployeeMasterApiData(data.data);
            setApiData(data.data);
            setCount(data.data.length);
            setLoading(false);
            setEmployeeMasterIds({ arr: [] });
            setChecked({ check: [] });
            setSelection(false);
            setPageCount(data.page_count);
            setMyCheckExport(data.selected_columns);
            setProgressFlg(false);
          }
        }
      }
    });
  }, [
    changeEmployeeMasterApiData,
    changeLoggedInData,
    currentPage,
    displayLimit,
    furigana,
    employeeType
  ]);

  const deleteSelectedEmployees = () => {
    deleteEmployeeMaster(employeeMasterIds.arr).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenAlert(false);
            getListOfEmployeeMasters();
          }
        }
      }
    });
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [furigana]);

  useEffect(() => {
    getListOfEmployeeMasters();
  }, [furigana, currentPage, displayLimit, employeeType]);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  function handleChange(index: number) {
    for (let i = 0; i < count; i++) {
      if (checked.check[i] === false) {
        setSelection(false);
      }
    }

    let checkedBox: any = [...checked.check];
    checkedBox[index] = !checked.check[index];
    setChecked({ check: checkedBox });
  }

  const selectAllCheckBoxPressed = () => {
    let a = [];
    if (isSelected === false) {
      let subjectArray: any = [];
      setEmployeeMasterIds({ arr: [] });

      setChecked({ check: [] });
      setPressed([]);
      for (let i = 1; i <= count; i++) {
        a.push(true);
        setChecked({ check: a });
      }

      apiData.map((item: any, k: number) => subjectArray.push(item.id));
      setEmployeeMasterIds({ arr: subjectArray });
    } else {
      setEmployeeMasterIds({ arr: [] });
      for (let i = 1; i <= count; i++) {
        a.push(false);
        setChecked({ check: a });
      }
    }
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleClickOpenActivate = () => {
    setOpenActivate(true);
  };
  const handleCloseActivate = () => {
    setOpenActivate(false);
  };
  const activateSelectedEmployee = () => {
    activateEmployeeById(idToActivate).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            setTimeout(() => {
              getListOfEmployeeMasters();
            }, 1500);
          }
        }
      }
    });
  };

  const handleExport = () => {
    getExportEmployeeItems(myCheckExport, furigana.trim(), employeeType).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setTransactionData(data.rows_list);
              csvLink.current.link.click();
              handleCloseModal();
            }
          }
        }
      }
    );
  };

  // 電話番号フォーマット用のユーティリティ関数
  const formatPhoneNumber = (value: any): string => {
    if (!value) return '';
    const phone = String(value);
    return phone.startsWith('0') ? phone : `0${phone}`;
  };

  // CSVデータ整形用の関数
  const formatCSVData = (rows: any[]): any[] => {
    return rows.map(row => {
      // ヘッダー行はそのまま返す
      if (Array.isArray(row) && typeof row[0] === 'string') {
        return row;
      }

      // データ行の場合、電話番号関連フィールドを処理
      return row.map((cell: any, index: number) => {
        // ヘッダーの内容に基づいて電話番号フィールドを識別
        const isPhoneField =
          Array.isArray(rows[0]) &&
          (rows[0][index] === '電話番号' ||
            rows[0][index] === '緊急連絡先電話番号' ||
            rows[0][index] === '保険番号' ||
            rows[0][index] === '年金番号');

        if (isPhoneField && cell) {
          // cellが存在する場合のみクオーテーションを追加
          return `'${formatPhoneNumber(cell)}'`;
        }
        return cell;
      });
    });
  };

  //社員情報管理カスタマイズCSV出力
  const handleCustomExport = () => {
    // エクスポート対象のIDsを設定
    const exportIds = {
      arr:
        employeeMasterIds.arr.length > 0
          ? employeeMasterIds.arr // 選択されているユーザーがいる場合
          : apiData.map((item: any) => item.id) // 選択されているユーザーがいない場合は全ユーザー
    };
    getExportCustomEmployeeItems(exportIds).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            const formattedData = formatCSVData(data.rows_list);
            setTransactionData(formattedData);
            csvLink.current.link.click();
            handleCloseModal();
          }
        }
      }
    });
  };

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userPermission === 2 || userPermission === 3) {
    return <NotFoundPage />;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='employee_masters' />
      {loading === true || userPermission === undefined ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSuccess}
            autoHideDuration={4000}
            onClose={handleCloseSuccess}
          >
            <Alert onClose={handleClose} severity='success'>
              {successMessage}
            </Alert>
          </Snackbar>

          <Dialog
            open={openAlert}
            onClose={handleCloseAlert}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {'削除しますか？'}
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCloseAlert} color='primary'>
                キャンセル
              </Button>
              <Button
                onClick={() => {
                  deleteSelectedEmployees();
                }}
                color='primary'
                autoFocus
              >
                削除
              </Button>
            </DialogActions>
          </Dialog>

          {/* 社員一覧タブ */}
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: matches2 ? 'row' : 'column'
              }}
              className={classes.topList}
            >
              <div
                onClick={() => {
                  setCurrentPage(1);
                  setEmployeeType(EMPLOYEE_TYPE['INSIDE_EMPLOYEE']);
                }}
                className='border2'
                style={{
                  backgroundColor: employeeType == 1 ? '#F5F5F5' : '#ffffff',
                  borderTopColor: employeeType == 1 ? '#0099CB' : '#cccccc',
                  borderBottom:
                    employeeType == 1 ? 'none' : 'solid 1px #cccccc',
                  width: 200
                }}
              >
                <div
                  className={classes.topColumn}
                  style={{ color: employeeType == 1 ? '#0099CB' : '#000000' }}
                >
                  自社社員
                </div>
              </div>
              {/* 社外パートナータブ */}
              <div
                onClick={() => {
                  setCurrentPage(1);
                  setEmployeeType(EMPLOYEE_TYPE['OUTSIDE_PARTNER']);
                }}
                className='border2'
                style={{
                  backgroundColor: employeeType == 2 ? '#F5F5F5' : '#ffffff',
                  borderTopColor: employeeType == 2 ? '#0099CB' : '#cccccc',
                  borderBottom:
                    employeeType == 2 ? 'none' : 'solid 1px #cccccc',
                  width: 200
                }}
              >
                <div
                  className={classes.topColumn}
                  style={{ color: employeeType == 2 ? '#0099CB' : '#000000' }}
                >
                  社外パートナー
                </div>
              </div>
              <div
                // 空アイテム
                className='empty-list'
                style={{ flexGrow: 1 }}
              ></div>
            </div>
          </div>

          {/* ふりがな検索 */}
          <div>
            <div className={classes.searchInput}>
              <input
                style={{ backgroundColor: '#FFFFFF' }}
                className={classes.formControl1}
                placeholder='ふりがな'
                maxLength={50}
                onChange={text => {
                  setFurigana(text.target.value);
                }}
              />
              <Button
                style={{
                  marginTop: matches2 ? 0 : 15,
                  marginLeft: 20,
                  backgroundColor: buttonColor
                }}
                onClick={() => {
                  getListOfEmployeeMasters();
                }}
                variant='contained'
                color='primary'
              >
                検索
              </Button>
            </div>
          </div>

          {/* ボタンエリア */}
          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div className={classes.buttonArea}>
              <div style={{ display: 'flex' }}>
                <div style={{ marginRight: 10 }} className='select-div'>
                  <div style={{ paddingLeft: 5 }}>
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={displayLimit}
                        onChange={e => {
                          setCurrentPage(1);
                          setDisplayLimit(parseInt(e.target.value));
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        {/* <option value={0}>
                        結果の制限</option> */}
                        <option value={10}>10件</option>
                        <option value={30}>30件</option>
                        <option value={50}>50件</option>
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    marginRight: 10,
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  startIcon={<NoteAddIcon />}
                  onClick={() => {
                    history.push('/employee-masters/create', {
                      actionType: 'create',
                      employeeType: employeeType
                    });
                  }}
                >
                  新規作成
                </Button>
                <CustomTooltip
                  title={tooltipContents.employeeMasterSelectDelete}
                  placement='top'
                >
                  <Button
                    style={{
                      backgroundColor: buttonColor,
                      marginRight: 10,
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    startIcon={<DeleteIcon />}
                    onClick={() => {
                      if (employeeMasterIds.arr.length <= 0) {
                        alert('対象を選択してください。');
                      } else {
                        handleClickOpenAlert();
                      }
                    }}
                  >
                    選択削除
                  </Button>
                </CustomTooltip>
                {isEmployeeAddInfo ? (
                  <>
                    <CustomTooltip
                      title={tooltipContents.employeeMasterExport}
                      placement='top'
                    >
                      <Button
                        style={{
                          backgroundColor: buttonColor,
                          marginBottom: !matches2 ? 10 : 0
                        }}
                        onClick={handleCustomExport}
                        variant='contained'
                        color='secondary'
                        startIcon={<GetAppIcon />}
                      >
                        エクスポート
                      </Button>
                    </CustomTooltip>
                    <CSVLink
                      data={transactionData}
                      filename='社員マスタ.csv'
                      className='hidden'
                      ref={csvLink}
                      target='_blank'
                    />
                  </>
                ) : (
                  <CustomTooltip
                    title={tooltipContents.employeeMasterExport}
                    placement='top'
                  >
                    <Button
                      style={{
                        backgroundColor: buttonColor,
                        marginBottom: !matches2 ? 10 : 0
                      }}
                      onClick={handleOpenModal}
                      variant='contained'
                      color='secondary'
                      startIcon={<GetAppIcon />}
                    >
                      エクスポート
                    </Button>
                  </CustomTooltip>
                )}
              </div>
            </div>
            <Dialog
              fullWidth={fullWidth}
              maxWidth={maxWidth}
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby='max-width-dialog-title'
            >
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  <div>
                    <div
                      className='border1'
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      <div style={{ flex: 3 }}>
                        <div
                          style={{ padding: 10, backgroundColor: mainColor }}
                        >
                          <div style={{ color: '#FFFFFF' }}>エクスポート</div>
                        </div>
                      </div>
                    </div>

                    {filteredCheckListOptions.map((i: any, index) => (
                      <div
                        className='border1'
                        style={{ display: 'flex', flexDirection: 'row' }}
                      >
                        <div
                          style={{
                            flex: 3,
                            backgroundColor:
                              index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
                          }}
                        >
                          <div style={{ padding: 3 }}>
                            <Checkbox
                              name='expertCheckbox'
                              checked={
                                myCheckExport.includes(
                                  Object.keys(i).toString()
                                )
                                  ? true
                                  : false
                              }
                              onClick={e => {
                                var ind = myCheckExport.indexOf(
                                  Object.keys(i).toString()
                                );
                                if (ind === -1) {
                                  setMyCheckExport([
                                    ...myCheckExport,
                                    Object.keys(i).toString()
                                  ]);
                                } else {
                                  setMyCheckExport(
                                    myCheckExport.filter(
                                      (char: any, aa: any) => aa !== ind
                                    )
                                  );
                                }
                              }}
                              style={{
                                color: myCheckExport.includes(
                                  Object.keys(i).toString()
                                )
                                  ? buttonColor
                                  : '#758283'
                              }}
                            />
                            {Object.values(i)}
                          </div>
                        </div>
                      </div>
                    ))}
                    <div></div>
                  </div>
                </DialogContentText>
              </DialogContent>
              <div
                style={{
                  marginBottom: 20,
                  marginTop: 10,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Button
                  style={{ backgroundColor: buttonColor }}
                  variant='contained'
                  color='primary'
                  onClick={handleExport}
                  startIcon={<GetAppIcon />}
                >
                  保存
                </Button>
                <CSVLink
                  data={transactionData}
                  filename='社員マスタ.csv'
                  className='hidden'
                  ref={csvLink}
                  target='_blank'
                />
              </div>
            </Dialog>
            <Dialog
              open={openActivate}
              onClose={handleCloseActivate}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>
                {'有効化しますか？'}
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleCloseActivate} color='primary'>
                  キャンセル
                </Button>
                <Button
                  onClick={() => {
                    handleCloseActivate();
                    activateSelectedEmployee();
                  }}
                  color='primary'
                  autoFocus
                >
                  はい
                </Button>
              </DialogActions>
            </Dialog>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='left'>
                      <CustomTooltip
                        title={tooltipContents.selectDelete}
                        placement='top'
                      >
                        <Checkbox
                          checked={isSelected}
                          onClick={() => {
                            setSelection(!isSelected);
                            selectAllCheckBoxPressed();
                          }}
                          style={{
                            color: isSelected ? buttonColor : '#FFFFFF'
                          }}
                        />
                      </CustomTooltip>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      氏名
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      メールアドレス
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      電話番号
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      社員グループ名
                    </StyledTableCell>
                    {employeeType == EMPLOYEE_TYPE['OUTSIDE_PARTNER'] && (
                      <StyledTableCell className={classes.table} align='center'>
                        業者名
                      </StyledTableCell>
                    )}
                    <StyledTableCell className={classes.table} align='center'>
                      最終ログイン
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      ステータス
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {apiData.map((row: any, index: number) => (
                    <StyledTableRow key={row.id} className='click_table_row'>
                      <StyledTableCell
                        style={{ minWidth: 45 }}
                        className={classes.table1}
                        align='left'
                      >
                        <CustomTooltip
                          title={tooltipContents.selectDelete}
                          placement='top'
                        >
                          <Checkbox
                            checked={checked.check[index] ? true : false}
                            onClick={() => {
                              handleChange(index);
                              let newArr = employeeMasterIds.arr;
                              if (!checked.check[index] && !pressed[index]) {
                                newArr.push(row.id);
                                setEmployeeMasterIds({ arr: newArr });
                              } else {
                                var ind = employeeMasterIds.arr.indexOf(row.id);
                                if (ind !== -1)
                                  employeeMasterIds.arr.splice(ind, 1);
                              }
                              setCheckBoxSelected(!checkBoxSelected);
                            }}
                            style={{
                              color: checked.check[index]
                                ? buttonColor
                                : '#758283'
                            }}
                          />
                        </CustomTooltip>
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/employee-masters/${row.id}/edit`, {
                            employeeId: row.id,
                            actionType: 'edit',
                            employeeType: employeeType
                          });
                        }}
                      >
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/employee-masters/${row.id}/edit`, {
                            employeeId: row.id,
                            actionType: 'edit',
                            employeeType: employeeType
                          });
                        }}
                      >
                        {row.email}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/employee-masters/${row.id}/edit`, {
                            employeeId: row.id,
                            actionType: 'edit',
                            employeeType: employeeType
                          });
                        }}
                      >
                        {row.tel}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/employee-masters/${row.id}/edit`, {
                            employeeId: row.id,
                            actionType: 'edit',
                            employeeType: employeeType
                          });
                        }}
                      >
                        {row.groups}
                      </StyledTableCell>
                      {employeeType == EMPLOYEE_TYPE['OUTSIDE_PARTNER'] && (
                        <StyledTableCell
                          className={classes.table1}
                          style={{ minWidth: 100 }}
                          align='center'
                          onClick={() => {
                            history.push(`/employee-masters/${row.id}/edit`, {
                              employeeId: row.id,
                              actionType: 'edit',
                              employeeType: employeeType
                            });
                          }}
                        >
                          {row.partner_name}
                        </StyledTableCell>
                      )}
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/employee-masters/${row.id}/edit`, {
                            employeeId: row.id,
                            actionType: 'edit',
                            employeeType: employeeType
                          });
                        }}
                      >
                        {row.last_login}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/employee-masters/${row.id}/edit`, {
                            employeeId: row.id,
                            actionType: 'edit',
                            employeeType: employeeType
                          });
                        }}
                      >
                        {row.enrollment_status}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        {row.status == '非アクティブ' ? (
                          <CustomTooltip
                            title={tooltipContents.employeeMasterActivation}
                            placement='top'
                          >
                            <Button
                              style={{ backgroundColor: buttonColor }}
                              variant='contained'
                              color='primary'
                              onClick={() => {
                                setIdToActivate(row.id);
                                handleClickOpenActivate();
                              }}
                            >
                              有効化
                            </Button>
                          </CustomTooltip>
                        ) : null}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
            <PaginationComponent
              page={currentPage}
              pageCount={pageCount}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
